var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date_picker_panel_components"},[_c('el-date-picker-panel',{attrs:{"startTime":_vm.startTime,"endTime":_vm.endTime,"defaultValue":_vm.defaultValue},on:{"selectDate":_vm.handleDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }